<div class="title-container">
    <h4 class="title">
        {{panelTitle}}
    </h4>

    <ng-content select=".filter-menu"></ng-content>
    <ng-content select=".title-page-action"></ng-content>
</div>
<ng-content></ng-content>
